import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  cardWrapper: {
    marginBottom: 15,
    borderRadius: 20,
    overflow: 'hidden',
  },
}));
